import React from 'react';
import {
  IconError,
  IconFailed,
  IconInfo,
  IconSuccess,
} from './icons';
import { cn } from '../utils/cn';

const Alert = ({ type = 'info', title, message, className }) => {
  const types = {
    success: {
      container: 'bg-green-50 border-green-200',
      icon: <IconSuccess className="h-5 w-5 text-green-600" />,
      title: 'text-green-800',
      message: 'text-green-700',
    },
    error: {
      container: 'bg-red-50 border-red-200',
      icon: <IconFailed className="h-5 w-5 text-red-600" />,
      title: 'text-red-800',
      message: 'text-red-700',
    },
    warning: {
      container: 'bg-yellow-50 border-yellow-200',
      icon: <IconError className="h-5 w-5 text-yellow-600" />,
      title: 'text-yellow-800',
      message: 'text-yellow-700',
    },
    info: {
      container: 'bg-blue-50 border-blue-200',
      icon: <IconInfo className="h-5 w-5 text-blue-600" />,
      title: 'text-blue-800',
      message: 'text-blue-700',
    },
  };

  const style = types[type] || types.info;

  return (
    <div className={cn('border rounded-lg p-4', style.container, className)}>
      <div className="flex">
        <div className="flex-shrink-0">{style.icon}</div>
        <div className="ml-3">
          {title && <h3 className={cn('text-sm font-medium', style.title)}>{title}</h3>}
          {message && (
            <div className={cn('text-sm mt-1', style.message)}>
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Alert;
